import React from "react";
import { CSSProperties, useEffect, useState } from "react";
import classes from "./SimpleButton.module.scss";

type ColorValiation = "orange" | "black" | "white" | "redOrange" | "green" | "gray" | "lightgreen";
export type SimpleButtonProps = {
  id?:string;
  label: string;
  onClick?: () => void;
  color?: ColorValiation;
  leftIcon?: string;
  rightIcon?: string;
  maxWidth?: string;
  maxHeight?: string;
  width?: string;
  isRadius?: boolean;
  disabled?: boolean;
  textColor?: string;
};

const classMap = {
  orange: classes.orange,
  black: classes.black,
  white: classes.white,
  redOrange: classes.redOrange,
  green: classes.green,
  gray: classes.gray,
  lightgreen:classes.lightgreen
};

const SimpleButton = (props: SimpleButtonProps) => {
  const cl = classMap[props.color ?? "orange"];

  const style = (() => {
    const tmp: CSSProperties = {};

    if (props.maxWidth != null) {
      tmp.maxWidth = props.maxWidth;
    }

    if (props.maxHeight != null) {
      tmp.maxHeight = props.maxHeight;
    }

    if (props.width != null) {
      tmp.width = props.width;
    }

    if (props.isRadius) {
      tmp.borderRadius = "24rem";
    }

    if (props.textColor) {
      tmp.color = props.textColor;  
    }
    return tmp;
  })();

  return (
    <button
      className={`${cl} ${props.disabled ? classes.disabled : ""}`}
      style={style}
      disabled={props.disabled}
      onClick={() => {
        if (props.disabled || !props.onClick) {
          return;
        }
        props.onClick();
      }}
    >
      {props.leftIcon != null && (
        <img className={classes.leftIcon} src={props.leftIcon} />
      )}
      {props.label}
      {props.rightIcon != null && (
        <img className={classes.rightIcon} src={props.rightIcon} />
      )}
    </button>
  );
};

export default SimpleButton;
